import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const bypassToken = (length: number = 817) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.";
  let token = "03AFcWeA";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters[randomIndex];
  }

  return token;
};

export const useInvisibleReCAPTCHA = () => {
  const [isExecuting, setIsExecuting] = useState<boolean>(false);
  const ref = useRef<ReCAPTCHA | undefined>();

  const executeAsync = async (): Promise<string> => {
    setIsExecuting(true);

    const promise = window.BYPASS_CAPTCHA
      ? new Promise<string>((resolve) => resolve(bypassToken()))
      : ref.current.executeAsync();

    await promise;

    !window.BYPASS_CAPTCHA && ref.current.reset();
    setIsExecuting(false);

    return promise;
  };

  return { isExecuting, ref, executeAsync };
};
